export interface PageFilterProps {
  isSortAndFilterButtonActive: boolean;
  availableQuickFilters: string[];
  badgeCount: number;
  toggleSortAndFilter: () => void;
  updateQuickFilter: (arg: string) => void;
  isPLP?: boolean;
}

export enum QuickFilterKey {
  ALL = '',
  NEW = 'NEW',
  PROMOTION = 'PROMOTION',
  TRENDING = 'TRENDING',
  SUBSCRIPTION = 'SUBSCRIPTION',
}
